import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../components/modal"
import { useState } from "react"

interface Props {
    open: boolean,
    onClose: () => void,
    onAgree: () => void
}

export const WarningModal = ({
    onAgree,
    onClose,
    open
}: Props) => {
    const [agree, setAgree] = useState(false)
    return (
        <ModalComponent
            open={open}
            onClose={onClose}
            title="Leia com atenção"
            titleProps={{
                color: "primary",
                fontWeight: "700",
                ml: "2.5%"
            }}
        >
            <Typography fontStyle={"italic"} textAlign={"justify"} fontSize={"1.2rem"} ml={"2.5%"} width={"90%"} mb={"2rem"}>
                Em caso de inadimplência, haverá a incidência de multa, juros de mora diária, honorários advocatícios, a inclusão do CPF e CNPJ na lista de devedores junto ao Serasa e serão tomadas todas as medidas de cobranças cabíveis.
            </Typography>

            <FormControlLabel
                control={<Checkbox checked={agree} onChange={(e) => setAgree(e.target.checked)} />}
                label={<Typography ml={"-1.5rem"} color="primary" fontSize={"1.4rem"} fontWeight={600}>Confirmo que li e concordo</Typography>}
                sx={{
                    width: "80%",
                    ml: "7.5%",
                    mb: "2rem",
                }}
                color="primary"
            />

            <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem"
                    }}
                    variant="contained"
                    disabled={!agree}
                    onClick={onAgree}
                >Continuar</Button>
            </Grid>
        </ModalComponent>
    )
}